/* global ReactOnRails */

import ApplicationController from './application_controller'

const HEADERS = {
  'X-CSRF-Token': document.querySelector("[name='csrf-token']")?.content,
  'Content-Type': 'application/json'
}

class DashboardContentLoaderController extends ApplicationController {
  static values = { url: String, delay: Number }

  connect () {
    this.element.classList.add('loading')

    if (this.delayValue) {
      setTimeout(this._load.bind(this), this.delayValue)
    } else {
      this._load()
    }
  }

  _load () {
    fetch(this.urlValue, { headers: HEADERS })
      .then(response => response.text())
      .then(html => {
        this.element.classList.remove('loading')

        this.element.innerHTML = html

        ReactOnRails.reactOnRailsPageLoaded()
      })
  }
}

export default DashboardContentLoaderController
